/**
 * Interface pro rozsireni vstupu filtrovani, pokud je zadano, pouziva se jina nez hlavni oparace (vyuzito na DateTimeWithInclude)
 */
export interface IStructureExtension {
    subOperationID: string;
}

export class IStructureExtension {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null &&
            Reflect.has(instance, "subOperationID");
    }
}
